import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconFormula = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="16.46"
    height="13.009"
    viewBox="0 0 16.46 13.009"
    {...props}
  >
    <g transform="translate(0 -46.742)">
      <path
        d="M15.727,48.208H7.741L4.607,59.242a.734.734,0,0,1-.673.508H3.909a.733.733,0,0,1-.681-.461l-1.281-3.2H.733a.733.733,0,0,1,0-1.466h1.71a.733.733,0,0,1,.681.461l.71,1.775,2.675-9.606a.733.733,0,0,1,.7-.509h8.52a.733.733,0,1,1,0,1.466Zm.395,9.848-2.889-3.245,2.753-3.056a.183.183,0,0,0-.136-.306H14.108a.184.184,0,0,0-.139.063l-1.848,2.143-1.834-2.142a.183.183,0,0,0-.139-.064H8.327a.183.183,0,0,0-.136.3l2.722,3.057L8.047,58.057a.183.183,0,0,0,.137.3H9.989a.182.182,0,0,0,.141-.066L12.043,56,14,58.3a.184.184,0,0,0,.14.064h1.845a.183.183,0,0,0,.136-.305Z"
        transform="translate(0 0)"
      />
    </g>
  </SVG>
)

export default withIconStyles(IconFormula)
